export default __webpack_public_path__ + "static/3-c67da0d4ce4d786b930a42e356d82206.webp";